import React from 'react'
import PropTypes from 'prop-types'
import HistoryFilters from './HistoryFilters'
import HistoryTable from './HistoryTable'
import HandoverDetailDrawer from './HandoverDetailDrawer'

const SewingHandoverHistoryPage = ({
    filters, partners, handedByList, loading, items, total, page, summary,
    detailVisible, detailLoading, detail,
    onSearch, onReset, onChangePage, onViewDetail, onCloseDetail, onPrint,
}) => {
    return (
        <div className='SewingHandoverHistoryPage'>
            <h2 className='PageTitle'>Lịch sử giao may</h2>

            <HistoryFilters
                filters={filters}
                partners={partners}
                handedByList={handedByList}
                loading={loading}
                onSearch={onSearch}
                onReset={onReset}
            />

            <div className='HistoryPanel'>
                <div className='HistorySummary'>
                    Tổng <b>{summary.total_handovers}</b> lần giao · <b>{summary.total_batches}</b> lô · <b>{summary.total_quantity}</b> item
                </div>

                <HistoryTable
                    loading={loading}
                    items={items}
                    total={total}
                    page={page}
                    onChangePage={onChangePage}
                    onViewDetail={onViewDetail}
                    onPrint={onPrint}
                />
            </div>

            <HandoverDetailDrawer
                visible={detailVisible}
                loading={detailLoading}
                detail={detail}
                onClose={onCloseDetail}
                onPrint={onPrint}
            />
        </div>
    )
}

SewingHandoverHistoryPage.propTypes = {
    filters: PropTypes.object.isRequired,
    partners: PropTypes.array.isRequired,
    handedByList: PropTypes.array.isRequired,
    loading: PropTypes.bool.isRequired,
    items: PropTypes.array.isRequired,
    total: PropTypes.number.isRequired,
    page: PropTypes.number.isRequired,
    summary: PropTypes.object.isRequired,
    detailVisible: PropTypes.bool.isRequired,
    detailLoading: PropTypes.bool.isRequired,
    detail: PropTypes.object,
    onSearch: PropTypes.func.isRequired,
    onReset: PropTypes.func.isRequired,
    onChangePage: PropTypes.func.isRequired,
    onViewDetail: PropTypes.func.isRequired,
    onCloseDetail: PropTypes.func.isRequired,
    onPrint: PropTypes.func.isRequired,
}

export default SewingHandoverHistoryPage
